import React, { useEffect, useState } from "react";
import "./OrderPopup.css";
import { FaClock } from "react-icons/fa";
import { useSelector } from "react-redux";

const OrderPopup = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [fadeOut, setFadeOut] = useState(false);

  const orderDetails = useSelector((state) => state.cart.orderDetails);

  useEffect(() => {
    if (orderDetails?.createdAt) {
      // Convert to UK time zone
      const ukTime = new Date(
        new Date(orderDetails.createdAt).toLocaleString("en-GB", {
          timeZone: "Europe/London",
        })
      );

      // Get hour and minute
      const hour = ukTime.getHours();
      const minute = ukTime.getMinutes();

      // If time is after 12:00 PM
      if (hour > 12 || (hour === 12 && minute > 0)) {
        setShowPopup(true);
      }
    }
  }, [orderDetails?.createdAt]);

  const handleClose = () => {
    setFadeOut(true);
    setTimeout(() => {
      setShowPopup(false);
    }, 300);
  };

  if (!showPopup) return null;

  return (
    showPopup && (
      <div className="popup-overlay">
        <div className={`popup-content ${fadeOut ? "fade-out" : ""}`}>
          <button className="close-button" onClick={handleClose}>
            ×
          </button>
          {/* <div className="popup-left">
            <img src={popupImg} alt="Newsletter" />
          </div> */}
          <div className="popup-right">
            <div className="popup-heading">
              <FaClock className="info-icon" />
              <h2>Next Working Day Dispatch</h2>
            </div>
            <p>
              Orders placed after 12:00 PM (UK time) will be dispatched the next
              working day.
            </p>
          </div>
        </div>
      </div>
    )
  );
};

export default OrderPopup;
